import { useEffect, useRef, useState } from "react";

/**
 * Returns a `stuck` boolean that flips true if `isLoading` is still true after
 * `thresholdMs` milliseconds (default 30 000). Resets automatically if
 * `isLoading` becomes false before the threshold fires.
 */
export function useInitStuckDetector(isLoading: boolean, thresholdMs = 30000): boolean {
  const [stuck, setStuck] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!isLoading) {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setStuck(false);
      return;
    }

    timerRef.current = setTimeout(() => {
      setStuck(true);
    }, thresholdMs);

    return () => {
      if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isLoading, thresholdMs]);

  return stuck;
}
